/**
 * SYMSVOX Protocol - Contract Addresses
 * Base Sepolia (Chain ID: 84532)
 */

export const CHAIN_ID = 84532;

export const CONTRACTS = {
  agent: '0xf1B1cd3a28F416AD865014C4F63698e550b22225' as const,
  vault: '0x9bCB1D5A7656AE6D878c9519148E3E4E4D54a29c' as const,
  slashing: '0x0Cc3699463edFc94414D96390f15b425fB9b5267' as const,
  identity: '0x55238c1D8Ca264f2326874aB72320b8bdCeD001d' as const,
  reputation: '0xCb0c86e41B8f24fD6cA3eD01d68520B22272CB52' as const,
  oracle: '0xB9B7dE3FFf6c9C814765721cb61B95F0D5b994a2' as const,
  escrow: '0xb50457e4EAD2b1F02c8c017ce9998E097AAad291' as const,
} as const;

export const USDC_ADDRESS = '0x036CbD53842c5426634e7929541eC2318f3dCF7e' as const;
